import React, { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { getRole } from "../../auth/roleService";
import { menuByRole } from "../../config/menus";

const Sidebar = ({ collapsed, onToggle }) => {
  const location = useLocation();
  const role = getRole();
  const menuItems = menuByRole[role] || [];

  const [openMenu, setOpenMenu] = useState(null);

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + "/");
  };

  const isChildActive = (children) => {
    return children?.some(child => isActive(child.path));
  };

  const toggleMenu = (label) => {
    setOpenMenu(openMenu === label ? null : label);
  };

  const renderMenuItem = (item) => {

    // MENU WITH CHILDREN
    if (item.children) {
      const activeChild = isChildActive(item.children);
      const isOpen = openMenu === item.label || activeChild;

      return (
        <li key={item.label} className={`nav-item has-sub ${isOpen ? "open" : ""}`}>

          <div
            className={`nav-link ${activeChild ? "active" : ""}`}
            onClick={() => toggleMenu(item.label)}
          >
            <i className={item.icon}></i>
            <span>{item.label}</span>
            <i className={`fas fa-angle-right nav-arrow ${isOpen ? "rotate" : ""}`}></i>
          </div>

          {isOpen && (
            <ul className="submenu">
              {item.children.map(child => (
                <li key={child.path} className="nav-sub-item">
                  <Link
                    to={child.path}
                    className={`nav-sublink ${isActive(child.path) ? "active" : ""}`}
                  >
                    {child.label}
                  </Link>
                </li>
              ))}
            </ul>
          )}

        </li>
      );
    }

    // NORMAL MENU
    return (
      <li key={item.path} className="nav-item">
        <Link
          to={item.path}
          className={`nav-link ${isActive(item.path) ? "active" : ""}`}
        >
          <i className={item.icon}></i>
          <span>{item.label}</span>
        </Link>
      </li>
    );
  };

  const mainItems = menuItems.filter((item) => item.section === "main");
  const pageItems = menuItems.filter((item) => item.section === "pages");

  return (
    <aside className={`dashboard-sidebar ${collapsed ? "collapsed" : ""}`}>

      <div className="sidebar-header">
        <div className="sidebar-logo">
          <img
            src="/assets/images/fortrade_logo.png"
            alt="BSB FORTRADE"
            className="sidebar-logo-img"
          />
        </div>

        <button
          className="sidebar-toggle"
          onClick={onToggle}
          aria-label="Toggle sidebar"
        >
          <i className="fas fa-angle-double-left"></i>
        </button>
      </div>

      <nav className="sidebar-nav">
        <ul className="nav-menu-list">

          {mainItems.map(renderMenuItem)}

          {pageItems.length > 0 && (
            <>
              <li className="nav-section">
                <span className="nav-section-title">PAGES</span>
              </li>

              {pageItems.map(renderMenuItem)}
            </>
          )}

        </ul>
      </nav>

    </aside>
  );
};

export default Sidebar;